import { UPDATE_DROPDOWN } from "../actions"

const initialDropdownData = {
  MaritalStatus: [],
  LIFE_CLAIMANT_FAMILY_LEFT: [],
  LifeClaimantRelationship: [],
}

const dropdownDataReducer = (state = initialDropdownData, action) => {
  switch (action.type) {
    case UPDATE_DROPDOWN:
      switch (action.dropdownName) {
        case "MARITAL_STATUS":
          return { ...state, MaritalStatus: action.dropdownItems }
        case "LIFE_CLAIMANT_FAMILY_LEFT":
          return { ...state, LIFE_CLAIMANT_FAMILY_LEFT: action.dropdownItems }
        case "LIFE_CLAIMANT_RELATIONSHIP":
          return { ...state, LifeClaimantRelationship: action.dropdownItems }
        default:
      }
      break
    default:
  }

  return state
}

export default dropdownDataReducer
